// extracted by mini-css-extract-plugin
export default {"role":"role_role__56VH5","role__switch--editor":"role_role__switch--editor__DNViM"};